import { styled } from '@mui/material/styles';
import { Button, Tab, Tabs } from '@mui/material';
import React, { useEffect, useRef } from 'react'
import { TabContext, TabPanel } from '@mui/lab';
import { useSelector } from 'react-redux';


import { TabDefinition } from '../TabDefinition/TabDefinition';
import './CreateIncentive.css';
import { tabConfig } from '../TabDefinition/tabConfig';
import { useBeforeUnload, useLocation } from 'react-router-dom';
import { changeIncentiveTab, updateIncentiveData } from '../../../stateManagement/actions/incentiveActions';
import { useNavigate } from 'react-router-dom';
import { IncentiveCreateRequest } from '../types';
import moment from 'moment';
import DefaultHeading from '../../../components/heading/DefaultHeading';
import { openPopup } from '../../../stateManagement/actions/popupActions';


const StyledTabs = styled((props: any) => (
    <Tabs
        {...props}
        TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
    />
))({
    '& .MuiTabs-indicator': {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
    '& .MuiTabs-indicatorSpan': {
        width: '60%',
        backgroundColor: 'var(--incentive-dark-blue)'
    },
});

const StyledTab = styled((props: any) => (
    <Tab disableRipple {...props} />
))(({ theme }) => ({
    textTransform: 'none',
    marginRight: '10px',
    borderRadius: '5px',
    fontSize: '17px',

    '&.Mui-selected': {
        color: 'var(--incentive-dark-blue)',
        background: 'var(--incentive-light-blue)',
    },
    '&.Mui-focusVisible': {
        backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
    '&.Mui-disabled': {
        cursor: 'not-allowed'
    }
}));



export const CreateIncentive = () => {

    const valueMappingFromApi: any = {
        "MONTH": "MONTHLY",
        "PERIOD": "PERIOD",
        "WEEK": "WEEKLY",
        "SALESTARGET": "Sales Target",
        "CROSSSELL": "Cross Sell",
        "UPSELL": "Recover",
        "FOCUS": "Focus Product",
        "CROSSSELLPARENT": "Cross Sell",
        "UPSELLPARENT": "Recover",
        "FOCUSPARENT": "Focus Product"
    };



    const tabsContentRef = useRef<HTMLDivElement>(null);
    const { currentTab } = useSelector((state: any) => state.manageIncentive?.pageData);
    const location: any = useLocation();
    const navigate = useNavigate();
    const storeData: Record<string, any> = useSelector((state: any) => state?.manageIncentive?.data);

    useBeforeUnload(
        React.useCallback(() => {
            localStorage.incentiveData = JSON.stringify(storeData);
        }, [storeData])
    );

    useEffect(() => {
        if (tabsContentRef && tabsContentRef.current) {
            tabsContentRef.current.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }, [currentTab])

    useEffect(() => {
        let dataToEdit: any = null;
        if (localStorage.incentiveData) {
            dataToEdit = JSON.parse(localStorage.incentiveData);
            delete localStorage.incentiveData
        }
        changeIncentiveTab("0");
        // Transform period and kpi values
        const transformedData = { ...dataToEdit };

        // Transform the period
        if (transformedData.period && transformedData.period.value) {
            transformedData.period.value = valueMappingFromApi[transformedData.period.value] || transformedData.period.value;
        }

        // Transform the kpi names
        if (transformedData.kpi && transformedData.kpi.value) {
            transformedData.kpi.value = transformedData.kpi.value.map((kpi: any) => ({
                ...kpi,
                name: valueMappingFromApi[kpi.name] || kpi.name
            }));
        }

        // Create initial component state with transformed data
        const initialComponentState: any = {};
        tabConfig.forEach(tabDetails => {
            const tabDefinition = tabDetails.tabDefinition;
            tabDefinition.tabComponents.forEach((tabComponent, index) => {
                if (!initialComponentState[tabComponent.stateName]) {
                    const prevState = transformedData[tabComponent.stateName];
                    initialComponentState[tabComponent.stateName] = {
                        label: tabComponent.label,
                        reset: false,
                        isOpen: index === 0 || (prevState ? prevState.isOpen : false),
                        isDisabled: false,
                        value: prevState?.value || null,
                        isValid: prevState?.isValid ? true : false
                    };
                    if (index + 1 < tabDefinition.tabComponents.length) {
                        initialComponentState[tabComponent.stateName].childState = tabDefinition.tabComponents[index + 1].stateName;
                    }
                }
            });
        });

        // Update incentive data with the initial state
        updateIncentiveData(initialComponentState);
    }, []);

    const handleOnTabChange = async (event: React.SyntheticEvent, newValue: string) => {
        if(newValue>currentTab){

        }else if(newValue<currentTab){
            changeIncentiveTab(newValue);
        }
    }

    const validateAllData = ()=>{
        let flag:boolean = true;
        tabConfig.forEach(tabDetails=>{
            tabDetails.tabDefinition.tabComponents.forEach(tabComponent=>{
                flag = flag && storeData[tabComponent.stateName].isValid;
            })
        })
        return flag;
    }

    const onSubmit = () => {
        if(!validateAllData()){
            openPopup('Alert','Please fill and save all the feilds properly');
            return;
        }
        const valueMappingFromUI: any = {};
        Object.entries(valueMappingFromApi).forEach(([key, value]: [any, any]) => {
            valueMappingFromUI[value] = key;
        });

        const designation = [];
        const kpiWithPoints = [];
        const redemptionValue = [];
        const bodyObject: IncentiveCreateRequest = {
            "action": `${storeData.calculationType?.value}`,
            "description": "",
            "amountOrQuantity": null,
            "duration": valueMappingFromUI[storeData.period?.value] || `${storeData.period?.value}`,
            "incentiveName": `${storeData.incentiveName?.value}`,
            "startTime": `${moment(storeData.storedDates?.value?.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')} 00:00:00`,
            "endTime": `${moment(storeData.storedDates?.value?.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')} 23:59:59`,
            "extendedAttributes": { "pjp": "true" },
            "activeStatus": 'active'
        }
        if (storeData.user?.value) {
            for (var userData of storeData.user?.value) {
                const reversedDesignation = valueMappingFromUI[userData.name] || userData.name;
                designation.push(reversedDesignation);
            }
        }
        bodyObject.designations = designation;
        if (storeData.kpi?.value) {
            for (var kpi of storeData.kpi?.value) {
                const reversedKpiName = valueMappingFromUI[kpi.name] || kpi.name;
                kpiWithPoints.push({
                    "name": reversedKpiName,
                    "point": parseInt(kpi.points)
                });
            }
        }
        bodyObject.kpiWithPoints = kpiWithPoints;
        if (storeData.threshold?.value) {
            for (var threshold of storeData.threshold?.value) {
                redemptionValue.push({
                    "startPercentage": parseInt(threshold.fromRange),
                    "endPercentage": parseInt(threshold.toRange),
                    "value": parseInt(threshold.rangeValue)
                })
            }
        }

        bodyObject.redemptionValue = redemptionValue;
        localStorage.incentiveData = JSON.stringify(storeData);
        navigate('preview', { state: { bodyObject } });
    }


    const finalSubmitButton = () => {
        return (
            <div className='incentive-next-button-wrapper'>
                <Button
                    className='incentive-next-button'
                    variant="contained"
                    sx={{
                        marginLeft: 2,
                        height: 35,
                        fontSize: '0.8rem',
                        marginTop: 2,
                        marginRight: 1
                    }}
                    onClick={onSubmit}
                >
                    SAVE AND PREVIEW
                </Button>
            </div>
        );
    }

    return (
        <div className='incentive-dashboard-wrapper' style={{ height: '100%', backgroundColor: "white" }}>
                <TabContext value={currentTab}>
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <StyledTabs onChange={handleOnTabChange} variant="fullWidth" value={currentTab}>
                            {tabConfig.map((tabDetails, index) => {
                                return (
                                    <StyledTab style={{ cursor: 'pointer' }} label={tabDetails.tabName} value={index + ""} />
                                );
                            })}
                        </StyledTabs>
                        <div className="define-incentive-tab-content" style={{ padding: '5px 10px', flex: 1, overflowY: 'auto' }} ref={tabsContentRef}>
                            {tabConfig.map((tabDetails, index) => {
                                return (
                                    <TabPanel className="define-incentive-tab-content" value={index + ''}>
                                        <TabDefinition tabDefinition={tabDetails.tabDefinition} tabNumber={index + ''} finalSubmitButton={index === tabConfig.length - 1 ? finalSubmitButton : undefined} />
                                    </TabPanel>
                                );
                            })}
                        </div>
                    </div>
                </TabContext>

        </div>
    );
}